import React from 'react'
import PropTypes from 'prop-types'

import { Typography, makeStyles } from '@material-ui/core'

import styles from './styles'

const useStyles = makeStyles(styles)

const CardHeaderColor = ({ title, color = 'primary', children }) => {
  const classes = useStyles()

  return (
    <div className={`${classes.root} ${classes[color]}`}>
      {title ? (
        <Typography className={classes.text}>{title}</Typography>
      ) : (
        children
      )}
    </div>
  )
}

CardHeaderColor.propTypes = {
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'info',
    'warning',
    'error',
  ]),
  title: PropTypes.string,
  children: PropTypes.any,
}

export default CardHeaderColor
